<div class="sub-project-type" [ngClass]="subProjectDisplay.typeClass">
  {{ subProjectDisplay.typeDisplay }}
</div>

<ng-container *ngIf="subProjectDisplay.type === SUB_PROJECT_TYPES.BASE_PROJECT">
  <ng-container
    *ngTemplateOutlet="
      baseProject;
      context: { subProjectDisplay: subProjectDisplay }
    "
  >
  </ng-container>
</ng-container>

<ng-container *ngIf="subProjectDisplay.type !== SUB_PROJECT_TYPES.BASE_PROJECT">
  <ng-container
    *ngTemplateOutlet="
      adjustment;
      context: { subProjectDisplay: subProjectDisplay }
    "
  >
  </ng-container>
</ng-container>

<ng-template #baseProject let-subProjectDisplay="subProjectDisplay">
  <div class="sub-project-detail">
    <ng-container *ngIf="subProjectDisplay.products?.length > 0">
      <div class="product-detail">
        <div class="placement-image-container">
          <div
            class="placement-image"
            [ngStyle]="backgroundImageStyle != null ? backgroundImageStyle : {}"
            (click)="openAlbum(subProjectDisplay.products[0].lightboxAlbum)"
          ></div>
        </div>
        <hr />
        <div class="sub-project-info">
          <span
            class="click-link"
            [routerLink]="[
              '/project',
              subProjectDisplay.projectId,
              subProjectDisplay.id
            ]"
            >#{{ subProjectDisplay.projectId }}</span
          >
          <span *ngIf="subProjectDisplay.customerDisplay?.length > 0">
            - {{ subProjectDisplay.customerDisplay }}</span
          >
        </div>
        <div class="sub-project-info">
          {{ subProjectDisplay.executionDate | formatDate }} - werktijd:
          {{ subProjectDisplay.placementTimeHours }}:{{
            subProjectDisplay.placementTimeMinutes
          }}u
        </div>
        <div class="sub-project-info-with-placer">
          <div>
            <ng-container
              *ngTemplateOutlet="
                placer;
                context: { placer: subProjectDisplay.firstPlacer }
              "
            ></ng-container>
            <span>
              {{
                subProjectDisplay.products[0].typeDisplay
                  | shortenText: 25
                  | joiner: ' - ':subProjectDisplay.products[0].formatDisplay
              }}
            </span>
          </div>
        </div>
        <div class="sub-project-info">
          {{
            subProjectDisplay.address?.line1
              | printAddress
                : subProjectDisplay.address?.postalCode
                : subProjectDisplay.address?.city
          }}
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #adjustment let-subProjectDisplay="subProjectDisplay">
  <div class="sub-project-detail">
    <div class="placement-image-container">
      <div
        class="placement-image"
        [ngStyle]="backgroundImageStyle != null ? backgroundImageStyle : {}"
        (click)="openAlbum(subProjectDisplay.lightboxAlbum)"
      ></div>
    </div>
    <hr />
    <div class="sub-project-info">
      <span
        class="click-link"
        [routerLink]="[
          '/project',
          subProjectDisplay.projectId,
          subProjectDisplay.id
        ]"
        >#{{ subProjectDisplay.projectId }}</span
      >
      <span *ngIf="subProjectDisplay.customerDisplay?.length > 0">
        - {{ subProjectDisplay.customerDisplay }}</span
      >
    </div>
    <div class="sub-project-info">
      {{ subProjectDisplay.executionDate | formatDate }} - werktijd:
      {{ subProjectDisplay.placementTimeHours }}:{{
        subProjectDisplay.placementTimeMinutes
      }}u
    </div>
    <div
      *ngFor="let product of subProjectDisplay.products; let first = first"
      class="d-flex sub-project-info-with-placer"
    >
      <div>
        <ng-container *ngIf="first">
          <ng-container
            *ngTemplateOutlet="
              placer;
              context: { placer: subProjectDisplay.firstPlacer }
            "
          ></ng-container>
        </ng-container>
        <span>
          {{
            product.typeDisplay
              | shortenText: 25
              | joiner: ' - ':product.formatDisplay
          }}
        </span>
      </div>
    </div>
    <div class="sub-project-info">
      {{
        subProjectDisplay.address?.line1
          | printAddress
            : subProjectDisplay.address?.postalCode
            : subProjectDisplay.address?.city
      }}
    </div>
  </div>
</ng-template>

<ng-template #placer let-placer="placer">
  <div
    *ngIf="placer != null"
    class="employee-initials in-the-middle display-inline rounded-circle"
    [matTooltip]="placer.user?.firstName | personName: placer.user?.lastName"
  >
    <span *ngIf="!placer.user?.profilePicture">
      {{ placer.user?.firstName | initials: placer.user?.lastName }}
    </span>
    <span *ngIf="placer.user?.profilePicture">
      <img
        class="rounded-circle"
        width="20px"
        height="20px"
        [src]="'/api/assets/' + placer.user?.profilePicture?.uuid + '/20'"
      />
    </span>
  </div>
</ng-template>
